import { Link } from "react-router-dom";
import { IoLogOutOutline, IoMoonOutline, IoSunnyOutline } from "react-icons/io5";
import { useAuth } from "@/features/auth/AuthContext";
import { useTheme } from "@/app/ThemeContext";

export function Topbar() {
  const { user, logout } = useAuth();
  const { theme, toggleTheme } = useTheme();

  const iconButton =
    "rounded-md p-1.5 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-700 dark:text-slate-400 dark:hover:bg-slate-700 dark:hover:text-slate-200";

  return (
    // 48px rather than 64px: the bar holds three controls and no title, and the
    // height it was taking came out of the working area on every screen.
    <header className="flex h-12 items-center justify-end gap-1 border-b border-slate-200 bg-white px-3 dark:border-slate-700 dark:bg-slate-800">
      <button type="button" onClick={toggleTheme} className={iconButton} aria-label="Toggle theme">
        {theme === "dark" ? <IoSunnyOutline size={17} /> : <IoMoonOutline size={17} />}
      </button>

      <Link
        to="/profile"
        className="flex items-center gap-2 rounded-md px-2 py-1 transition-colors hover:bg-slate-100 dark:hover:bg-slate-700"
      >
        {/* Initials stand in for an avatar and keep the name from being the only
            target; the role reads as a quiet tag rather than a second line. */}
        <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-100 text-[11px] font-semibold uppercase text-brand-700 dark:bg-brand-900/50 dark:text-brand-300">
          {(user?.firstName?.[0] ?? "") + (user?.lastName?.[0] ?? "")}
        </span>
        <span className="hidden text-sm leading-tight text-slate-700 dark:text-slate-200 sm:inline">
          {user?.firstName} {user?.lastName}
        </span>
        <span className="hidden rounded bg-slate-100 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-slate-500 dark:bg-slate-700 dark:text-slate-400 md:inline">
          {user?.role?.replace(/_/g, " ")}
        </span>
      </Link>

      <button type="button" onClick={() => logout()} className={iconButton} aria-label="Log out">
        <IoLogOutOutline size={17} />
      </button>
    </header>
  );
}
